// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-text-field--outlined > .v-input__control > .v-input__slot {\n  background: white !important;\n}\n", ""]);
// Exports
module.exports = exports;
